import { ArtistType } from '@api';
import { zodResolver } from '@hookform/resolvers/zod';
import { t } from 'i18next';
import { useForm, UseFormReturn } from 'react-hook-form';
import { z } from 'zod';

const TRANS_KEY = 'ARTIST_FORM_FIELDS.FORM_ERRORS';

const formSchema = z.object({
  name: z.string().min(2, { message: t(`artists:${TRANS_KEY}.NAME_REQUIRED`) }),
  abbreviation: z
    .string()
    .max(4, { message: t(`artists:${TRANS_KEY}.ABBREVIATION_MAX_LENGTH`) })
    .nullable(),
  artistLink: z.string().nullable(),
  website: z.string().nullable(),
  genres: z.array(z.string()),
  isDomesticArtist: z.boolean(),
  isFemaleAct: z.boolean(),
  comment: z.string().nullable(),
  organizationUnit: z.string().nullable(),
});

export type EditArtistFormSchemaType = z.infer<typeof formSchema>;

type UseEditArtistFormReturnType = UseFormReturn<EditArtistFormSchemaType>;

export const useEditArtistForm = (
  artist: ArtistType
): UseEditArtistFormReturnType => {
  return useForm({
    defaultValues: {
      name: artist.name,
      abbreviation: artist.abbreviation,
      artistLink: artist.artistLink,
      website: artist.website,
      genres: artist.genre,
      isDomesticArtist: artist.isDomesticArtist,
      isFemaleAct: artist.isFemaleAct,
      comment: artist.comment,
      organizationUnit: artist.defaultOrganizationUnit,
    },
    resolver: zodResolver(formSchema),
  });
};
